import { UserRole } from '@/models/User';

export const isSupplier = (userRole: UserRole): boolean => userRole === UserRole.SupplierAdmin;
